import { lazy, Suspense } from "react";
import { SubHeading } from "../Components";

const ManageBadlaBody = lazy(() => import("./ManageBadlaBody"));

const ManageBadla = () => {
  return (
    <>
      <SubHeading subTitle="Manage Badla" />

      <Suspense fallback={<>Loading</>}>
        <ManageBadlaBody />
      </Suspense>
    </>
  );
};

export default ManageBadla;
